<app-navbar-style-one></app-navbar-style-one>

<div class="inner-banner">
    <div class="container">
      
        <div class="inner-title text-center">
            <h3>الدفع</h3>
        </div>
    </div>
</div>
<div class="alert alert-success text-center" *ngIf="showSuccess" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;"> <!--*ngIf="showError" -->
    {{successMsg}}
</div>

<div class="alert alert-danger text-center" *ngIf="showError" style="position: fixed;top: 20%;direction: ltr;left: 50%;transform: translate(-50%, -50%);z-index: 99999999999999;"> <!--*ngIf="showError" -->
    برجاء تسجيل الدخول اولا
</div>
<section class="checkout-area pt-100 pb-70">
    <div class="container">
        <!-- <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="checkout-user">
                    <i class="fas fa-sign-out-alt"></i>
                    <span>Returning customer? <a routerLink="/login-register">Click here to Sign In</a></span>
                </div>
            </div>
        </div> -->
        <div class="address-container">
            <h3>اختر عنوان التسليم</h3>
            <div class="address-list">
                <div *ngFor="let address of addresses" class="address-item">
                    <label class="address-radio">
                        <input type="radio" name="mainAddress" [value]="address.id" 
                            [checked]="address.isMain" (change)="setMainAddress(address.id)">
                        <div class="address-details">
                            <div class="name">{{ user?.name | titlecase }}</div>
                            <div class="address">{{ formatAddress(address) }}</div>
                            <div class="phone">{{ phones?.phone || 'Your Phone' }}</div>
                        </div>
                        <span style="width: 25px;text-align: center;">
                            <a style="color: red;" (click)="deleteAddress(address.id)">
                                <i style="font-size: 18px;" class="fas fa-trash-alt"></i>
                            </a>
                        </span>
                    </label>
                </div>
                <div class="alert alert-danger" *ngIf="addressesCounter==0">
                    <p>لا يوجد عناوين تسليم</p>
                </div>
            </div>
        </div>

        <div class="contact-form" >
            <form [formGroup]="addAdressForm">
                <div class="row">
                    <div class="col-lg-6 col-md-12 address-container-section">
                        <div class="billing-details">
                            <h3 class="title"> <button (click)="toggleAddressForm()" class="default-btn" style="padding: 0px;background-color: #212660 !important;border-radius: 200px;width: 50px;height: 50px;"><i class="plusMinus fa fa-plus-circle" style="margin-right: 0px;" aria-hidden="true"></i></button> إضافة عنوان اخر</h3>
    
                            <div class="row" *ngIf="showAddressForm">
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <i class='flaticon-parking'></i>
                                        <input type="text" name="city_id" id="city_id" class="form-control" formControlName="city_id" placeholder="المدينة">
                                        <div *ngIf="f2['city_id'].touched && f2['city_id'].invalid" class="error-msg text-start">
                                            <div *ngIf="f2['city_id'].hasError('required')">المدينة مطلوبة</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <i class='flaticon-place'></i>
                                        <input type="text" name="address" id="address" class="form-control" formControlName="address" placeholder="العنوان">
                                        <div *ngIf="f2['address'].touched && f2['address'].invalid" class="error-msg text-start">
                                            <div *ngIf="f2['address'].hasError('required')">العنوان مطلوب</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <i class='flaticon-buildings'></i>
                                        <input type="text" name="building" id="building" class="form-control" formControlName="building" placeholder="مبني">
                                        <div *ngIf="f2['building'].touched && f2['building'].invalid" class="error-msg text-start">
                                            <div *ngIf="f2['building'].hasError('required')">المبني مطلوب</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <i class='flaticon-workflow'></i>
                                        <input type="text" name="floor" id="floor" class="form-control" formControlName="floor" placeholder="الطابق">
                                        <div *ngIf="f2['floor'].touched && f2['floor'].invalid" class="error-msg text-start">
                                            <div *ngIf="f2['floor'].hasError('required')">الطابق مطلوب</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <i class='flaticon-event'></i>
                                        <input type="text" name="flat" id="flat" class="form-control" formControlName="flat" placeholder="الشقة">
                                        <div *ngIf="f2['flat'].touched && f2['flat'].invalid" class="error-msg text-start">
                                            <div *ngIf="f2['flat'].hasError('required')">الشقة مطلوبة</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="form-group">
                                        <i class='flaticon-position'></i>
                                        <input type="text" name="special_mark" id="special_mark" class="form-control" formControlName="special_mark" placeholder="علامة مميزة">
                                        <div *ngIf="f2['special_mark'].touched && f2['special_mark'].invalid" class="error-msg text-start">
                                            <div *ngIf="f2['special_mark'].hasError('required')">العلامة المميزة مطلوبة</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-12">
                                    <div class="order-details">
                                        <div class="payment-box p-0">
                                            <a routerLink="/checkout" (click)="addAddress()" class="default-btn w-100 three">إضافة</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div class="col-lg-6 col-md-12 order-details-section">
                        <div class="order-details">
                            <div class="order-table table-responsive">
                                <h3>تفاصيل طلباتك</h3>
                                <table class="table ">
                                    <thead>
                                        <tr>
                                            <th scope="col">بيانات المنتج</th>
                                            <th scope="col">المجموع</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of cart">
                                            <td class="product-name">
                                                <a>{{item.name}} - ( {{ getTypeName(item.types, item.selectedTypeId) }} ) - {{ getTypePrice(item.types, item.selectedTypeId) }} EGP</a>
                                            </td>
                                            <td class="product-total">
                                                <span class="subtotal-amount">{{ calculateSubtotal(item) }} EGP</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="order-subtotal">
                                                <span>اجمالي سلة التسوق</span>
                                            </td>
                                            <td class="order-subtotal-price">
                                                <span class="order-subtotal-amount">{{cartTotalPrice}} EGP</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="order-shipping">
                                                <span>التوصيل</span>
                                            </td>
                                            <td class="shipping-price">
                                                <span>{{deliveryCost}} EGP</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="order-shipping">
                                                <span>تكلفة الخدمة</span>
                                            </td>
                                            <td class="shipping-price">
                                                <span>{{serviceCost}} EGP</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="total-price">
                                                <span>إجمالي الطلب</span>
                                            </td>
                                            <td class="product-subtotal">
                                                <span class="subtotal-amount">{{ cartTotalPrice + deliveryCost + serviceCost }} EGP</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 confirm-order-section">
                        <div class="order-details">
                            <div class="payment-box">
                                <form [formGroup]="orderForm">
                                    <div class="col-lg-12">
                                        <div class="form-group">
                                            <textarea id="deliveryNote" name="deliveryNote" formControlName="deliveryNote" rows="5" class="form-control px-2" placeholder="اضافة ملاحظات ( اختياري )"></textarea>
                                        </div>
                                    </div>
                                </form>
                                <a (click)="confirmOrder()" class="default-btn w-100">تأكيد الطلب</a>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>

<!-- <app-footer-style-two></app-footer-style-two> -->